module.exports = __webpack_public_path__ + "3b156a92dc2bece3b445e50098b24d4e.jpg";